export default {
  'progress.prefix': 'Stap',
  'summary.target-date': 'Streefdatum',
  'summary.other-situation-values.box-street': 'Ik wil een <b>voetpadkastje in de straat</b> laten verplaatsen of verwijderen.',
  'summary.other-situation-values.box-facade': 'Ik wil een <b>netwerkkast in de straat</b> laten verplaatsen of verwijderen.',
  'summary.other-situation-values.connector-cable': 'Ik wil een <b>aansluitpunt</b> op een gevel of een paal laten verplaatsen of verwijderen.',
  'summary.other-situation-values.pole': 'Ik wil een <b>netwerkkabel</b> op een gevel, op een paal of naar mijn huis laten verplaatsen of verwijderen.',
  'date.proceed': 'Ga verder met deze datum',
  'date.confirm': 'Bevestig je gekozen datum.',
};
